/* ============================================
   FLAVOR THEME — Core JavaScript
   ============================================ */

(function () {
  'use strict';

  /* --- Utility: Fetch with section rendering --- */
  window.Flavor = window.Flavor || {};

  Flavor.fetchSection = function (url, sectionId) {
    var separator = url.includes('?') ? '&' : '?';
    return fetch(url + separator + 'section_id=' + sectionId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        return parser.parseFromString(html, 'text/html');
      });
  };

  Flavor.formatMoney = function (cents) {
    var format = Flavor.money_format || '€{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = Math.floor(cents / 100);
    var amountWithComma = amount.replace('.', ',');
    return format
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount_with_comma_separator}}', amountWithComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals);
  };

  /* --- Quick Add to Cart --- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();

    var formData = new FormData(form);
    var body = {};
    formData.forEach(function (v, k) { body[k] = v; });

    fetch(Flavor.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      Flavor.updateCartDrawer();
      Flavor.openCartDrawer();
    })
    .catch(function (err) { console.error('Quick add error:', err); });
  });

  /* --- Cart Drawer open/close --- */
  Flavor.openCartDrawer = function () {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  };

  Flavor.closeCartDrawer = function () {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  };

  /* --- Cart icon click opens drawer --- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-trigger]')) {
      e.preventDefault();
      Flavor.openCartDrawer();
    }
    if (e.target.closest('[data-cart-drawer-close]')) {
      Flavor.closeCartDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') Flavor.closeCartDrawer();
  });

  /* --- Update header cart count --- */
  Flavor.updateCartCount = function (count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  };

  /* --- Lazy load images with native loading="lazy" fallback --- */
  if ('IntersectionObserver' in window) {
    var imgObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          imgObserver.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });

    document.querySelectorAll('img[data-src]').forEach(function (img) {
      imgObserver.observe(img);
    });
  }

})();
